module.exports = __webpack_public_path__ + "static/media/manguera-verde.9102b4ea.svg";